import React from 'react';
import { ChipField, useRecordContext } from 'react-admin';
import { leadImportStatuses } from '../../leadImports.model';

interface StatusChipProps {
  record?: any;
  label?: string;
}

const StatusChip = ({ record: recordProp, ...props }: StatusChipProps) => {
  const contextRecord = useRecordContext(props);
  const record = recordProp || contextRecord;

  const getStatusColor = (status) => {
    switch (status) {
      case leadImportStatuses.COMPLETED:
        return 'success';
      case leadImportStatuses.FAILED:
        return 'error';
      case leadImportStatuses.PROCESSING:
        return 'warning';
      case leadImportStatuses.QUEUED:
        return 'info';
      case leadImportStatuses.CANCELLED:
        return 'default';
      case leadImportStatuses.ROLLED_BACK:
        return 'secondary';
      case leadImportStatuses.ROLLING_BACK:
        return 'warning';
      case leadImportStatuses.ROLLBACK_FAILED:
        return 'error';
      default:
        return 'default';
    }
  };

  if (!record) return null;

  return (
    <ChipField
      record={record}
      source="status"
      color={getStatusColor(record?.status)}
    />
  );
};

export default StatusChip;
